import * as React from "react";
import { Box, Grid } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import Header from '../../Components/Header/Header';
import { DashboardInfoContext, DashboardInfoPayload } from "../../Context/dashboardContext";
import { getLeftBlockStyles, getRightBlockStyles } from "../../Components/sidebar/getStyles";
import SideBar from "../../Components/sidebar/SideBar";
import styles from "./outerLayout.module.css";
import { JWT_KEY_FROM_URL } from "../../constants/jwtConstant";

const OuterLayout = () => {
    const { isSidebarCollapsed } = useContext(DashboardInfoContext) as DashboardInfoPayload;
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(globalThis.location?.search ?? '');
        if (params.get(JWT_KEY_FROM_URL) && location.pathname) {
            navigate(location.pathname, { replace: true });
        }
    }, []);

    const noBoxShadowPaths = new Set(['/threepscodes', '/insights', '/insights/moreInfo', '/agents', '/agents/agent']);

    const noBoxShadow = noBoxShadowPaths.has(location.pathname);

    return (
        <>
            <Grid container className={styles.mainOuterCtn}>
                <Grid item className={styles.leftBlock} sx={getLeftBlockStyles(isSidebarCollapsed)}>
                    <SideBar />
                </Grid>
                <Grid item sx={getRightBlockStyles(isSidebarCollapsed)}>
                    <Grid container className={styles.innerContainer}>
                        <Header
                            showEnv={true}
                            showLogo={false}
                            EnvName="Production"
                            height="60px"
                            width={isSidebarCollapsed ? "calc(100% - 79px)" : "calc(100% - 200px)"}
                            PortalName="Developer Portal" />
                        <Grid item className={styles.content}>
                            <Box className={noBoxShadow ? styles.noBoxShadowCtn : styles.boxShadowCtn}>
                                <Outlet />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default OuterLayout;